import React from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import ScoringCard from '~/components/ScoringCard/ScoringCard';
import CardHeader from '~/components/CardHeader/CardHeader';
import includes from 'lodash/includes';
import { ordinalize } from 'lodash-inflection';

import css from './ScoringSummary.scss';

const getSegmentTitle = (sportType, data) => {
  if (sportType === 'baseball') {
    return data.segment_description;
  }

  return data.segment_string || `${ordinalize(data.segment)} segment`;
};

const ScoringSummary = props => {
  const { sportType } = props;

  const SPORT_HOCKEY = 'hockey';

  if (!props.scorings) {
    return <div />;
  }

  if (!props.scorings.length) {
    return <div className={css.noScoringCard}>No scoring.</div>;
  }

  // map the scorings to the associated period or segment
  const periodType = sportType === SPORT_HOCKEY ? 'period' : 'segment';
  const periodNumbers = [];
  let periods = {};

  if (sportType !== 'baseball') {
    props.scorings.forEach(scoring => {
      const period = scoring[periodType];

      if (!includes(periodNumbers, period)) {
        periods[period] = [];
        periodNumbers.push(period);
      }
      periods[period].push(scoring);
    });
  }

  if (sportType === 'baseball') {
    periods = props.scorings.reduce((acc, elem) => {
      const segmentDescription = elem.segment_description;

      if (!acc[elem.segment_description]) {
        acc[segmentDescription] = [elem];
      } else {
        acc[elem.segment_description].push(elem);
      }

      return acc;
    }, {});
  }

  return (
    <div>
      {Object.keys(periods).map(key => (
        <div key={`period-${key}`} className={css.period}>
          <CardHeader>
            <div className={css.periodTitle}>{getSegmentTitle(sportType, periods[key][0])}</div>
          </CardHeader>
          {periods[key].map(scoring => (
            <div key={`period-${key}-${scoring.api_uri}`} className={css.scoringCard}>
              <ScoringCard scoring={scoring} key={scoring.id} sportType={sportType} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

ScoringSummary.propTypes = {
  scorings: PropTypes.array.isRequired,
  sportType: PropTypes.string.isRequired,
};

ScoringSummary.displayName = 'ScoringSummary';

export default StyledComponent(ScoringSummary, [css]);
